import { render, staticRenderFns } from "./ListaDeTrabalho.vue?vue&type=template&id=6ac5e093&"
import script from "./ListaDeTrabalho.vue?vue&type=script&lang=js&"
export * from "./ListaDeTrabalho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports